import { render } from "./full.vue?vue&type=template&id=36d353c0"
import script from "./full.vue?vue&type=script&lang=js"
export * from "./full.vue?vue&type=script&lang=js"

import "./full.vue?vue&type=style&index=0&id=36d353c0&lang=css"

import exportComponent from "C:\\Users\\shareTeam\\Desktop\\work\\parking\\duty-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__